import { Property } from 'csstype';
import { flexitemAlignSelf } from './flexitem.css';

type AlignSelf = Parameters<typeof flexitemAlignSelf>[0];

export type FlexitemProps = {
  alignSelf?: AlignSelf['alignSelf'];
  flex?: Property.Flex;
  order?: Property.Order;
};

const flexitemInterpolations = {
  alignSelf: ({ alignSelf }: Pick<FlexitemProps, 'alignSelf'>) =>
    alignSelf === undefined
      ? {}
      : {
          class: flexitemAlignSelf({ alignSelf })
        },
  flex: ({ flex }: Pick<FlexitemProps, 'flex'>) => (flex === undefined ? {} : { flex }),
  order: ({ order }: Pick<FlexitemProps, 'order'>) => (order === undefined ? {} : { order })
};

export { flexitemInterpolations };
